// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"504":"6007c803","820":"7eb45b58"}[chunkId] + ".chunk.js");